import { Link } from "react-router-dom";
import { Atom, Mail, ArrowUpRight } from "lucide-react";
import { services } from "@/data/services";

const navLinks = [
  { to: "/", label: "Home", id: "footer-home-link" },
  { to: "/about", label: "About", id: "footer-about-link" },
  { to: "/services", label: "Services", id: "footer-services-link" },
  { to: "/why-us", label: "Why Us", id: "footer-why-us-link" },
  { to: "/contact", label: "Contact", id: "footer-contact-link" },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-400" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <Atom className="h-7 w-7 text-coral-400" strokeWidth={1.5} />
              <span className="font-serif text-xl tracking-tight text-white">
                THREENNOVATORS <span className="text-coral-400">LLP</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed">
              Bridging Science, Medicine &amp; Innovation. End-to-end scientific,
              clinical, pharmaceutical, and research support for credible,
              compliant, and impactful outcomes.
            </p>
            <a
              href="mailto:contact@threenn.com"
              data-testid="footer-email-link"
              className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-coral-400 transition-colors hover:text-coral-300"
            >
              <Mail className="h-4 w-4" />
              contact@threenn.com
            </a>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              Navigate
            </p>
            <ul className="mt-5 space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={l.id}
                    className="text-sm transition-colors hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              Services
            </p>
            <ul className="mt-5 space-y-3">
              {services.slice(0, 5).map((s) => (
                <li key={s.id}>
                  <Link
                    to="/services"
                    className="text-sm transition-colors hover:text-white"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              Products
            </p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href="https://www.manuscriptnest.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-product-manuscript-nest"
                  className="text-sm transition-colors hover:text-white"
                >
                  Manuscript Nest
                </a>
              </li>
              <li>
                <a
                  href="https://www.resynote.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-product-resynote"
                  className="text-sm transition-colors hover:text-white"
                >
                  ResyNote
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              Start
            </p>
            <p className="mt-5 text-sm leading-relaxed">
              Global, remote-first. Every enquiry held under strict
              confidentiality.
            </p>
            <Link
              to="/contact"
              data-testid="footer-get-in-touch-button"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-coral-500/50 px-5 py-2.5 text-sm font-semibold text-coral-400 transition-colors duration-300 hover:bg-coral-500 hover:text-white"
            >
              Get in Touch
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} THREENNOVATORS LLP. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-600">
            Bridging Science, Medicine &amp; Innovation
          </p>
        </div>
      </div>
    </footer>
  );
}
